import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "page d-flex flex-row flex-column-fluid" }
const _hoisted_2 = {
  id: "kt_wrapper",
  class: "wrapper d-flex flex-column flex-row-fluid"
}
const _hoisted_3 = { class: "container-xxl" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger w-full mt-2 d-flex align-items-center justify-content-between p-4 mx-auto flex-wrap z-index-3"
}
const _hoisted_5 = {
  class: "d-flex align-items-center flex-wrap",
  style: {"gap":"20px"}
}
const _hoisted_6 = { class: "svg-icon svg-icon-2hx svg-icon-danger me-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-1 text-dark" }, "This is an alert"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-dark" }, "The alert component can be used to highlight certain parts of your page for higher content visibility.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Go settings ")
const _hoisted_9 = {
  id: "kt_content",
  class: "content d-flex flex-column flex-column-fluid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTLoader = _resolveComponent("KTLoader")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_KTHeader = _resolveComponent("KTHeader")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_KTFooter = _resolveComponent("KTFooter")!
  const _component_KTScrollTop = _resolveComponent("KTScrollTop")!
  const _component_KTCreateInvoiceModal = _resolveComponent("KTCreateInvoiceModal")!
  const _component_KTCreateAccountModal = _resolveComponent("KTCreateAccountModal")!
  const _component_KTUpgradePlanModal = _resolveComponent("KTUpgradePlanModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loaderEnabled)
      ? (_openBlock(), _createBlock(_component_KTLoader, {
          key: 0,
          logo: _ctx.loaderLogo
        }, null, 8, ["logo"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.$route.path !== '/account/settings' && _ctx.user.active == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                  ]),
                  _hoisted_7
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'account-settings' },
                  class: "btn btn-bg-danger text-white d-block"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.route.name !== 'home')
          ? (_openBlock(), _createBlock(_component_KTHeader, {
              key: 0,
              breadcrumbs: _ctx.breadcrumbs
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            id: "kt_content_container",
            class: _normalizeClass({
            'container-fluid': _ctx.contentWidthFluid,
            'container-xxl': !_ctx.contentWidthFluid,
          })
          }, [
            _createVNode(_component_router_view)
          ], 2)
        ]),
        _createVNode(_component_KTFooter)
      ])
    ]),
    _createVNode(_component_KTScrollTop),
    _createVNode(_component_KTCreateInvoiceModal),
    _createVNode(_component_KTCreateAccountModal),
    _createVNode(_component_KTUpgradePlanModal)
  ], 64))
}